import React from 'react';
interface OnboardingProgressBarProps {
  stage: 'anunt' | 'cont' | 'profil';
  subStep: number;
  listingOnly?: boolean;
}
export function OnboardingProgressBar({
  stage,
  subStep,
  listingOnly = false
}: OnboardingProgressBarProps) {
  let progress = 0;
  if (listingOnly) {
    // Listing-only mode: 6 anunț sub-steps (0..5) → 0%..100%
    progress = subStep / 5 * 100;
  } else {
    // Normal flow (Anunț → Profil → Cont):
    // anunț: 0..70%, profil: ~80%, cont: ~95%
    if (stage === 'anunt') {
      progress = subStep / 5 * 70;
    } else if (stage === 'profil') {
      progress = 80;
    } else if (stage === 'cont') {
      progress = 95;
    }
  }
  return <div className="w-full h-1 bg-dark-2 overflow-hidden" data-id="element-1504">
      <div className="h-full bg-lime-1 transition-all duration-500 ease-out" style={{
      width: `${progress}%`
    }} data-id="element-1505" />
    </div>;
}